import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@shortsworks/ui";
import { FormItemProps } from "@app/components/forms/types/props";
import { cn } from "@shortsworks/ui/lib/utils";
import {
  EmailInputSchema,
  TextInputSchema,
  UrlInputSchema,
} from "@app/components/forms/types/schema";

// debounce 옶션을 가지도록 관리
export const FormInput = ({
  form,
  schema,
  ...rest
}: FormItemProps<TextInputSchema | UrlInputSchema | EmailInputSchema>) => {
  // 숨김처리 되었을 required 와 충돌하는 점(input 엘리먼트를 렌더링하지 않는 등으로 처리 필요)
  // if(schema.behavior?.hidden) { return; }

  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => (
        <FormItem
          className={cn(
            schema.appearance?.className,
            schema.appearance?.border ? "border p-3 rounded-lg shadow-sm" : "",
            schema.behavior?.hidden && "hidden",
          )}
        >
          <FormLabel>
            {typeof schema.label === "function"
              ? schema.label(form.getValues())
              : schema.label}
          </FormLabel>
          <FormControl>
            <Input
              placeholder={schema.placeholder}
              {...field}
              {...schema.behavior}
            />
          </FormControl>
          {schema.description && (
            <FormDescription>
              {typeof schema.description === "function"
                ? schema.description(form.getValues())
                : schema.description}
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
